import { createApi } from "@reduxjs/toolkit/query/react";
import { API_BASE_URL } from "../../utils/constants";
import { axiosBaseQuery } from "../baseQuery";

import leaderboardParser from "../parser/leaderboardParser";

export const leaderboardApi: any = createApi({
  reducerPath: "leaderboardApi",
  baseQuery: axiosBaseQuery({ baseUrl: API_BASE_URL }),
  //   tagTypes: ["USER", "ROLE"],

  endpoints: (builder) => ({
    getLeaderboardList: builder.query<any, any>({
      query: (params: any) => ({
        url: `/leaderboard`,
        method: "GET",
        params: params,
      }),

      transformResponse: (res: any) => {
        return leaderboardParser.fetchLeaderboard(res);
      },
    }),

    getLeaderboardById: builder.query({
      query: ({id, params}) => ({
        url: `/leaderboard/${id}`,
        method: "GET",
        params: params,
      }),
      transformResponse: (res: any) => {
        return leaderboardParser.fetchLeaderboardbyid(res);
      },
    }),
  }),
});

export const { useGetLeaderboardListQuery, useLazyGetLeaderboardByIdQuery } =
  leaderboardApi;
